interface IconProps {
  className?: string;
}

export const RouteIcon = ({ className }: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.9703 7.04313C5.37433 7.04313 4.88672 6.55552 4.88672 5.95955C4.88672 5.36359 5.36349 4.87598 5.9703 4.87598H5.98113C6.5771 4.87598 7.06471 5.36359 7.06471 5.95955C7.06471 6.55552 6.5771 7.04313 5.9703 7.04313Z"
      fill="currentColor"
    />
    <path
      d="M20.0567 21.13C19.4608 21.13 18.9731 20.6424 18.9731 20.0465C18.9731 19.4505 19.4499 18.9629 20.0567 18.9629H20.0676C20.6635 18.9629 21.1511 19.4505 21.1511 20.0465C21.1511 20.6424 20.6635 21.13 20.0567 21.13Z"
      fill="currentColor"
    />
    <path
      d="M5.92698 10.5649C3.39141 10.5649 1.32178 8.49527 1.32178 5.9597C1.32178 3.42413 3.39141 1.35449 5.92698 1.35449C8.46255 1.35449 10.5322 3.42413 10.5322 5.9597C10.5322 8.49527 8.47339 10.5649 5.92698 10.5649ZM5.92698 2.97986C4.27994 2.97986 2.94714 4.31266 2.94714 5.9597C2.94714 7.60673 4.27994 8.93953 5.92698 8.93953C7.57402 8.93953 8.90682 7.60673 8.90682 5.9597C8.90682 4.31266 7.57402 2.97986 5.92698 2.97986Z"
      fill="currentColor"
    />
    <path
      d="M21.6393 24.6518H18.3885C16.7415 24.6518 15.4087 23.319 15.4087 21.672V18.4212C15.4087 16.7742 16.7415 15.4414 18.3885 15.4414H21.6393C23.2863 15.4414 24.6191 16.7742 24.6191 18.4212V21.672C24.6191 23.319 23.2863 24.6518 21.6393 24.6518ZM18.3885 17.0668C17.6409 17.0668 17.0341 17.6736 17.0341 18.4212V21.672C17.0341 22.4196 17.6409 23.0264 18.3885 23.0264H21.6393C22.3869 23.0264 22.9937 22.4196 22.9937 21.672V18.4212C22.9937 17.6736 22.3869 17.0668 21.6393 17.0668H18.3885Z"
      fill="currentColor"
    />
    <path
      d="M13.0027 21.4009H10.0987C8.84175 21.4009 7.74734 20.6424 7.3139 19.4722C6.86964 18.3019 7.19471 17.0124 8.13742 16.1781L16.7952 8.60387C17.3153 8.14877 17.3262 7.53113 17.1745 7.10853C17.0119 6.68594 16.6002 6.23083 15.9067 6.23083H13.0027C12.5584 6.23083 12.19 5.86242 12.19 5.41815C12.19 4.97389 12.5584 4.60547 13.0027 4.60547H15.9067C17.1636 4.60547 18.258 5.36397 18.6915 6.53424C19.1357 7.7045 18.8107 8.99396 17.8679 9.82831L9.21016 17.4025C8.69005 17.8576 8.67921 18.4753 8.83091 18.8979C8.99345 19.3205 9.40521 19.7756 10.0987 19.7756H13.0027C13.447 19.7756 13.8154 20.144 13.8154 20.5882C13.8154 21.0325 13.447 21.4009 13.0027 21.4009Z"
      fill="currentColor"
    />
  </svg>
);

export const VerticalDropIcon = ({ className }: IconProps) => (
  <svg
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.5 0L9 10H0L4.5 0Z"
      fill="currentColor"
    />
  </svg>
);

export const PisteLengthIcon = ({ className }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="5.5" cy="5" r="2.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M5.5 7.25C5.5 10.5 14.5 9.5 14.5 12.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="14.5" cy="15" r="2.25" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const LiftIcon = ({ className }: IconProps) => (
  <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
  <path d="M15.6788 14.3644C15.8602 14.3089 16.0283 14.2198 16.1733 14.1021C16.3182 13.9844 16.4373 13.8405 16.5235 13.6787C16.6098 13.5169 16.6615 13.3404 16.6757 13.1595C16.6899 12.9786 16.6663 12.7967 16.6062 12.6245L16.0504 12.7937C16.1221 13.0025 16.1039 13.2299 15.9998 13.426C15.8957 13.622 15.7141 13.7707 15.4949 13.8394L0.887365 18.5419L1.07543 19.0625L15.6788 14.3644ZM2.22802 6.2382C2.41822 6.18584 2.59569 6.09825 2.75027 5.98045C2.90485 5.86264 3.0335 5.71694 3.12884 5.55169C3.22417 5.38644 3.28433 5.2049 3.30585 5.01747C3.32738 4.83003 3.30984 4.6404 3.25426 4.45943C3.01991 3.70051 2.17757 3.26644 1.37359 3.48764C0.570027 3.70885 0.106322 4.50709 0.345264 5.26641C0.579619 6.02574 1.41988 6.45981 2.22802 6.2382ZM1.60794 8.22507C0.808552 6.78506 3.10248 5.61827 3.94732 7.015L5.59447 9.97406L8.73074 9.13173C9.24949 8.99273 9.96631 9.52688 9.96631 10.1555L9.98383 14.3727C9.98883 15.418 8.34501 15.4224 8.34501 14.3644C8.34001 13.3835 8.3129 11.2929 8.3129 11.2929L5.04028 12.221C4.32387 12.4164 3.73131 12.0785 3.45151 11.5793L1.60794 8.22507ZM6.67201 8.89345V0H5.838V9.06263L6.67201 8.89345ZM0.101735 10.1472C-0.348209 9.31005 0.813556 8.75485 1.2635 9.59201L2.68005 12.2123C2.83597 12.4879 3.06731 12.7181 3.34953 12.8786C3.63175 13.0391 3.95431 13.1238 4.28301 13.1237C4.4986 13.1237 4.70042 13.0713 4.89808 13.0324L6.68285 12.5384C7.62902 12.2691 7.99598 13.4486 7.04147 13.7143L5.16413 14.2298C4.87397 14.314 4.57217 14.3563 4.26883 14.3553C3.69877 14.3572 3.13914 14.2097 2.65121 13.9289C2.16328 13.6482 1.76586 13.245 1.50244 12.7635L0.101735 10.1472Z" fill="currentColor"/>
  </svg>
);

export const ElevationIcon = ({ className }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M1 17L7 6L11 13L14 8L19 17H1Z" fill="currentColor" />
  </svg>
);

export const MountGreenIcon = ({ className }: IconProps) => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.2291 15.6119L13.8628 0.379356C13.7238 0.145906 13.5014 0 13.2235 0C12.9733 0 12.7232 0.145906 12.5842 0.379356L8.1648 8.43336L6.74725 5.83624C6.60827 5.60279 6.38591 5.45688 6.10796 5.45688C5.85781 5.45688 5.60765 5.60279 5.46868 5.83624L0.104231 15.6119C-0.0347438 15.8454 -0.0347438 16.1372 0.104231 16.3706C0.243207 16.6041 0.465567 16.75 0.743518 16.75H4.85719H11.4724H21.5898C21.84 16.75 22.0901 16.6041 22.2291 16.3706C22.3681 16.1372 22.3681 15.8454 22.2291 15.6119Z"
      fill="#1CC775"
    />
  </svg>
);

export const MountBlueIcon = ({ className }: IconProps) => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.2291 15.6119L13.8628 0.379356C13.7238 0.145906 13.5014 0 13.2235 0C12.9733 0 12.7232 0.145906 12.5842 0.379356L9.58815 5.83942C8.97258 6.96125 7.36031 6.95944 6.74725 5.83624C6.60827 5.60279 6.38591 5.45688 6.10796 5.45688C5.85781 5.45688 5.60765 5.60279 5.46868 5.83624L0.104231 15.6119C-0.0347438 15.8454 -0.0347438 16.1372 0.104231 16.3706C0.243207 16.6041 0.465567 16.75 0.743518 16.75H4.85719H11.4724H21.5898C21.84 16.75 22.0901 16.6041 22.2291 16.3706C22.3681 16.1372 22.3681 15.8454 22.2291 15.6119Z"
      fill="#3185FA"
    />
  </svg>
);

export const MountRedIcon = ({ className }: IconProps) => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.2291 15.6119L13.8628 0.379356C13.7238 0.145906 13.5014 0 13.2235 0C12.9733 0 12.7232 0.145906 12.5842 0.379356L8.1648 8.43336L6.74725 5.83624C6.60827 5.60279 6.38591 5.45688 6.10796 5.45688C5.85781 5.45688 5.60765 5.60279 5.46868 5.83624L0.104231 15.6119C-0.0347438 15.8454 -0.0347438 16.1372 0.104231 16.3706C0.243207 16.6041 0.465567 16.75 0.743518 16.75H4.85719H11.4724H21.5898C21.84 16.75 22.0901 16.6041 22.2291 16.3706C22.3681 16.1372 22.3681 15.8454 22.2291 15.6119Z"
      fill="#EE2121"
    />
  </svg>
);

export const MountBlackIcon = ({ className }: IconProps) => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.2291 15.6119L13.8628 0.379356C13.7238 0.145906 13.5014 0 13.2235 0C12.9733 0 12.7232 0.145906 12.5842 0.379356L8.1648 8.43336L6.74725 5.83624C6.60827 5.60279 6.38591 5.45688 6.10796 5.45688C5.85781 5.45688 5.60765 5.60279 5.46868 5.83624L0.104231 15.6119C-0.0347438 15.8454 -0.0347438 16.1372 0.104231 16.3706C0.243207 16.6041 0.465567 16.75 0.743518 16.75H4.85719H11.4724H21.5898C21.84 16.75 22.0901 16.6041 22.2291 16.3706C22.3681 16.1372 22.3681 15.8454 22.2291 15.6119Z"
      fill="#171A1F"
    />
  </svg>
);

export const CopyIcon = ({ className }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6 12.0007C5.63333 12.0007 5.31944 11.8701 5.05833 11.609C4.79722 11.3479 4.66667 11.034 4.66667 10.6673V2.66732C4.66667 2.30065 4.79722 1.98676 5.05833 1.72565C5.31944 1.46454 5.63333 1.33398 6 1.33398H12C12.3667 1.33398 12.6806 1.46454 12.9417 1.72565C13.2028 1.98676 13.3333 2.30065 13.3333 2.66732V10.6673C13.3333 11.034 13.2028 11.3479 12.9417 11.609C12.6806 11.8701 12.3667 12.0007 12 12.0007H6ZM3.33333 14.6673C2.96667 14.6673 2.65278 14.5368 2.39167 14.2757C2.13056 14.0145 2 13.7007 2 13.334V4.00065H3.33333V13.334H10.6667V14.6673H3.33333Z"
      fill="white"
    />
  </svg>
);

export const MinusIcon = ({ className }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.16699 10H15.8337"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ className }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 4.16699V15.8337M4.16699 10H15.8337"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownIcon = ({ className }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = ({ className }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3334 4L6.00002 11.3333L2.66669 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = ({ className }: IconProps) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.75 0.75C4.75 0.334375 4.41563 0 4 0C3.58437 0 3.25 0.334375 3.25 0.75V2H2C0.896875 2 0 2.89687 0 4V4.5V6V14C0 15.1031 0.896875 16 2 16H12C13.1031 16 14 15.1031 14 14V6V4.5V4C14 2.89687 13.1031 2 12 2H10.75V0.75C10.75 0.334375 10.4156 0 10 0C9.58438 0 9.25 0.334375 9.25 0.75V2H4.75V0.75ZM1.5 6H12.5V14C12.5 14.275 12.275 14.5 12 14.5H2C1.725 14.5 1.5 14.275 1.5 14V6Z"
      fill="currentColor"
    />
  </svg>
);

export const SearchIcon = ({ className }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14L11.1 11.1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = ({ className }: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.6875 7C12.6875 8.50842 12.0883 9.95506 11.0217 11.0217C9.95506 12.0883 8.50842 12.6875 7 12.6875C5.49158 12.6875 4.04494 12.0883 2.97833 11.0217C1.91172 9.95506 1.3125 8.50842 1.3125 7C1.3125 5.49158 1.91172 4.04494 2.97833 2.97833C4.04494 1.91172 5.49158 1.3125 7 1.3125C8.50842 1.3125 9.95506 1.91172 11.0217 2.97833C12.0883 4.04494 12.6875 5.49158 12.6875 7ZM0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7ZM6.34375 3.28125V7C6.34375 7.21875 6.45312 7.42383 6.63633 7.54688L9.26133 9.29688C9.56211 9.49922 9.96953 9.41719 10.1719 9.11367C10.3742 8.81016 10.2922 8.40547 9.98867 8.20312L7.65625 6.65V3.28125C7.65625 2.91758 7.36367 2.625 7 2.625C6.63633 2.625 6.34375 2.91758 6.34375 3.28125Z"
      fill="currentColor"
    />
  </svg>
);

export const PeopleIcon = ({ className }: IconProps) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.5 0C5.16304 0 5.79893 0.263392 6.26777 0.732233C6.73661 1.20107 7 1.83696 7 2.5C7 3.16304 6.73661 3.79893 6.26777 4.26777C5.79893 4.73661 5.16304 5 4.5 5C3.83696 5 3.20107 4.73661 2.73223 4.26777C2.26339 3.79893 2 3.16304 2 2.5C2 1.83696 2.26339 1.20107 2.73223 0.732233C3.20107 0.263392 3.83696 0 4.5 0ZM16 0C16.663 0 17.2989 0.263392 17.7678 0.732233C18.2366 1.20107 18.5 1.83696 18.5 2.5C18.5 3.16304 18.2366 3.79893 17.7678 4.26777C17.2989 4.73661 16.663 5 16 5C15.337 5 14.7011 4.73661 14.2322 4.26777C13.7634 3.79893 13.5 3.16304 13.5 2.5C13.5 1.83696 13.7634 1.20107 14.2322 0.732233C14.7011 0.263392 15.337 0 16 0ZM0 9.33438C0 7.49375 1.49375 6 3.33437 6H4.66875C5.16562 6 5.6375 6.10938 6.0625 6.30312C6.02187 6.52812 6.00313 6.7625 6.00313 7C6.00313 8.19375 6.52812 9.26562 7.35625 10C7.35 10 7.34375 10 7.33437 10H0.665625C0.3 10 0 9.7 0 9.33438ZM12.6656 10C12.6594 10 12.6531 10 12.6438 10C13.475 9.26562 13.9969 8.19375 13.9969 7C13.9969 6.7625 13.975 6.53125 13.9375 6.30312C14.3625 6.10625 14.8344 6 15.3313 6H16.6656C18.5063 6 20 7.49375 20 9.33438C20 9.70312 19.7 10 19.3344 10H12.6656ZM7 7C7 6.20435 7.31607 5.44129 7.87868 4.87868C8.44129 4.31607 9.20435 4 10 4C10.7956 4 11.5587 4.31607 12.1213 4.87868C12.6839 5.44129 13 6.20435 13 7C13 7.79565 12.6839 8.55871 12.1213 9.12132C11.5587 9.68393 10.7956 10 10 10C9.20435 10 8.44129 9.68393 7.87868 9.12132C7.31607 8.55871 7 7.79565 7 7ZM4 15.1656C4 12.8656 5.86562 11 8.16562 11H11.8344C14.1344 11 16 12.8656 16 15.1656C16 15.625 15.6281 16 15.1656 16H4.83437C4.375 16 4 15.6281 4 15.1656Z"
      fill="currentColor"
    />
  </svg>
);

export const LocationIcon = ({ className }: IconProps) => (
  <svg
    width="11"
    height="15"
    viewBox="0 0 11 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.17891 14.6629C7.64844 12.7772 11 8.20679 11 5.63959C11 2.52607 8.53646 0 5.5 0C2.46354 0 0 2.52607 0 5.63959C0 8.20679 3.35156 12.7772 4.82109 14.6629C5.17344 15.1124 5.82656 15.1124 6.17891 14.6629ZM5.5 3.75973C5.98623 3.75973 6.45255 3.95779 6.79636 4.31033C7.14018 4.66287 7.33333 5.14102 7.33333 5.63959C7.33333 6.13817 7.14018 6.61632 6.79636 6.96886C6.45255 7.3214 5.98623 7.51946 5.5 7.51946C5.01377 7.51946 4.54745 7.3214 4.20364 6.96886C3.85982 6.61632 3.66667 6.13817 3.66667 5.63959C3.66667 5.14102 3.85982 4.66287 4.20364 4.31033C4.54745 3.95779 5.01377 3.75973 5.5 3.75973Z"
      fill="currentColor"
    />
  </svg>
);

export const TrashIcon = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3 6h18M8 6V4h8v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11v6M14 11v6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CrossIcon = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronLeftIcon = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningIcon = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M12 3.5L21.5 20H2.5L12 3.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M12 9v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="17.25" r="1" fill="currentColor" />
  </svg>
);
